import { render, staticRenderFns } from "./SchoolLabels.vue?vue&type=template&id=78efa875&"
import script from "./SchoolLabels.vue?vue&type=script&lang=js&"
export * from "./SchoolLabels.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLabels.vue?vue&type=style&index=0&id=78efa875&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports